import { Injectable } from '@angular/core';
import {AppConfig} from '../app.config';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RankService {
  private rankingUrl = this.config.baseUrl + 'api/rank';
  private rankingForAuthUserUrl = this.config.baseUrl + 'api/rank/user';
  private todayAllRankUrl = this.config.baseUrl + 'api/rank/?date=today';
  private yesterdayAllRankUrl = this.config.baseUrl + 'api/rank/?date=yesterday';
  private weekAllRankUrl = this.config.baseUrl + 'api/rank/?date=this_week';
  private monthAllRankUrl = this.config.baseUrl + 'api/rank/?date=this_month';
  private todayUserRankUrl = this.config.baseUrl + 'api/rank/user/?date=today';
  private weekUserRankUrl = this.config.baseUrl + 'api/rank/user/?date=this_week';
  private monthUserRankUrl = this.config.baseUrl + 'api/rank/user/?date=this_month';
  constructor(private config: AppConfig,
              private http: HttpClient) { }
  ranking(): Observable<any>{
    return this.http.get(this.rankingUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  rankingForAuthUser(): Observable<any>{
    return this.http.get(this.rankingForAuthUserUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map((response: Response) => {``
      return response;
    }));
  }
  todayAllRank(): Observable<any>{
    return this.http.get(this.todayAllRankUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  yesterdayAllRank(): Observable<any>{
    return this.http.get(this.yesterdayAllRankUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  weekAllRank(): Observable<any>{
    return this.http.get(this.weekAllRankUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  monthAllRank(): Observable<any>{
    return this.http.get(this.monthAllRankUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  todayUserRank(): Observable<any>{
    return this.http.get(this.todayUserRankUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  weekUserRank(): Observable<any>{
    return this.http.get(this.weekUserRankUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  monthUserRank(): Observable<any>{
    return this.http.get(this.monthUserRankUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  testUserRank(): any{
    return this.http.get(this.rankingForAuthUserUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
}
